import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken as FGetToken,
  MessagePayload,
  onMessage,
} from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCr_Uh6x4532EXji8xN_x0iJQpEeagUCQs",
  authDomain: "tcatgo-26459.firebaseapp.com",
  databaseURL:
    "https://tcatgo-26459-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "tcatgo-26459",
  storageBucket: "tcatgo-26459.firebasestorage.app",
  messagingSenderId: "1036080110994",
  appId: "1:1036080110994:web:31809e3fcce07820b1f54b",
  measurementId: "G-NSNJYSV958",
};

const msgKey =
  "BF0RKBCsbd9oUgvwpE44B30Mg9WIY4LvI1ZsiFHmjmnSmSmQypSkeDW6f1OQlYK23xtWyvel__X2gGfb7NIiLcM";

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export const getToken = async (): Promise<string | null> => {
  try {
    let currentToken = await FGetToken(messaging, { vapidKey: msgKey });
    if (currentToken) {
      console.log("current token for client: ", currentToken);
      return currentToken;
    } else {
      console.log(
        "No registration token available. Request permission to generate one.",
      );
      return null;
    }
  } catch (error) {
    console.log("An error occurred while retrieving token. ", error);
    throw error;
  }
};

export const onMessageListener = (): Promise<MessagePayload> =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
